<!--
  Oprl - doplňková mapová nástrojová nabídka
  Vychází z MapOt_Opr2
  zapoznámkovány vrstvy které nejsou v SSL
-->
<template>

  <div class="d-flex flex-row align-end" v-if="MapLayer_NLI_OPR2_visible">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5 " width="40" min-width="40" min-height="40" :color="ViewLeg ? 'info' : ''" v-bind="attrs"
          v-on="on" @click="MapLayerLegendDynamicSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda map OPRL</span>
    </v-tooltip>

    <v-card height="64" width="250" color="info" class="MapPnlGrdItem elevation-5"
      v-if="MapLayer_NLI_OPR2_ZLES.layer.visible">
      <v-autocomplete v-model="OprlSearch_Suggest_model" class="mb-3 mx-4" :items="OprlSearch_Suggest_items"
        :loading="OprlSearch_Suggest_isLoading" :search-input.sync="OprlSearch_Suggest_search" hide-details="true"
        hide-no-data item-text="userData.suggestFirstRow" item-value="userData.bbox"
        label="Vyhledat lesní cestu podle kódu" prepend-icon="mdi-map-search" clearable hide-selected return-object
        :filter="OprlSearch_Filter">
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.userData.suggestFirstRow"></v-list-item-title>
            <v-list-item-subtitle v-text="item.userData.suggestSecondRow"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-card>

    <Teleport to="#MapLayerLegendDynamicObj" v-if="ViewLeg">
      <div id="MapLegendPanel" class="MlPanel">

        <!-- <div class="" v-if="MapLayer_NLI_OPR2_PMAP.layer.visible">
          <div class="MlNadpis_01">Přehledová mapa</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_PMAP.png'" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_LVST.layer.visible">
          <div class="MlNadpis_01">Lesní vegetační stupně</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_LVST.png'" />

        </div> -->
        <div class="" v-if="MapLayer_NLI_OPR2_CHSO.layer.visible">
          <div class="MlNadpis_01">Cílové hospodářské soubory</div>

          <div>
            <!-- Legenda bez výběru ( zobrazeno v měřítku nad VybIles.Legenda.EditableMinScale)  -->
            <v-list dense color="toolBar2">
              <template v-for="item in FeatureLayer_NLI_OPRL2_CHSO.Legenda.Seznam">

                <v-list-item v-if="(typeof item.RocnikPodminka == 'undefined') ||
                  (VybRok >= item.RocnikPodminka.RocnikMin &&
                    VybRok <= item.RocnikPodminka.RocnikMax)" :key="item.Kod">

                  <!-- Se šrafou -->
                  <v-list-item-avatar v-if="item.Srafa" class="my-1" tile color="white" height="30">
                    <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                      <defs>
                        <!-- definice výplně - šrafy -->
                        <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth"
                          :height="item.Srafa.PatternHeight" patternUnits="userSpaceOnUse">
                          <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                            :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                          </path>
                        </pattern>
                      </defs>
                      <!-- případná barva podkladu -->
                      <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                      <!-- výplň - šrafa -->
                      <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
                    </svg>
                  </v-list-item-avatar>

                  <!-- Bez šrafy -->
                  <v-list-item-avatar v-else class="my-1" tile :color="item.Barva" height="30"/>

                  <div class="MlNadpis_01">{{ item.Popis }}</div>

                  <!-- <v-list-item-title v-text="item.Popis"></v-list-item-title> -->
                </v-list-item>

              </template>
            </v-list>

          </div>

        </div>

        <div class="" v-if="MapLayer_NLI_OPR2_LTYP.layer.visible">
          <div class="MlNadpis_01">Lesnická typologie</div>

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_ZLES.layer.visible">
          <div class="MlNadpis_01">Zpřístupnění lesa</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_ZLES_s_m.png'" v-if="MapScale > 64000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_ZLES_v.png'" v-if="MapScale <= 64000" />

        </div>
        <!-- <div class="" v-if="MapLayer_NLI_OPR2_OLES.layer.visible">
          <div class="MlNadpis_01">Ochrana lesa</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OLES_m.png'" v-if="MapScale > 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OLES_s.png'"
            v-if="MapScale > 64000 && MapScale <= 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OLES_v.png'" v-if="MapScale <= 64000" />
        </div>

        <div class="" v-if="MapLayer_NLI_OPR2_OPRI.layer.visible">
          <div class="MlNadpis_01">Ochrana přírody</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPRI_m.png'" v-if="MapScale > 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPRI_s.png'"
            v-if="MapScale > 64000 && MapScale <= 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPRI_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_OVOD.layer.visible">
          <div class="MlNadpis_01">Ochrana vody</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OVOD_m.png'" v-if="MapScale > 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OVOD_s.png'"
            v-if="MapScale > 64000 && MapScale <= 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OVOD_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_OPUD.layer.visible">
          <div class="MlNadpis_01">Ochrana půdy</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPUD_m.png'" v-if="MapScale > 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPUD_s.png'"
            v-if="MapScale > 64000 && MapScale <= 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_OPUD_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_RZDR.layer.visible">
          <div class="MlNadpis_01">Reprodukční zdroje</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_RZDR_m.png'" v-if="MapScale > 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_RZDR_s.png'"
            v-if="MapScale > 64000 && MapScale <= 512000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_RZDR_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_SFUN.layer.visible">
          <div class="MlNadpis_01">Sociální funkce</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_SFUN_s_m.png'" v-if="MapScale > 64000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_SFUN_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_MYSL.layer.visible">
          <div class="MlNadpis_01">Obory a bažantnice</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_MYSL_s_m.png'" v-if="MapScale > 64000" />
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_MYSL_v.png'" v-if="MapScale <= 64000" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_POSP.layer.visible">
          <div class="MlNadpis_01">Potenciální ohrožení smrkových porostů klimatickou změnou</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_POSP.png'" />

        </div>
        <div class="" v-if="MapLayer_NLI_OPR2_PSOU.layer.visible">
          <div class="MlNadpis_01">Provozní soubory</div>
          <img class="" :src="AssetsUrl + '/img/legend/mapa_NLI_OPR2_PSOU.png'" />

        </div> -->

      </div>

    </Teleport>



  </div>
</template>

<script>
  import AppOpr2 from "../../../assets/MapOt_Opr2.json";

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},

    // webová služba
    ServiceMap: null,
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,


      // Vybraná položka
      OprlSearch_Suggest_model: null,
      // Seznam položek
      OprlSearch_Suggest_items: [],
      // Načítám z webu
      OprlSearch_Suggest_isLoading: false,
      // hledám
      OprlSearch_Suggest_search: null,

      // Vybrané prvky legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Jméno legendy
      MapLayerLegendDynamic_contentName: "MapOT_Opr2_legend",
      // Nadpis legendy
      MapLayerLegendDynamic_title: "Oblastní plány rozvoje lesů",


      // Seznam vrstev
      LayerList: [],


    };
  },



  computed: {
    // Vrstvy OPRL
    // MapLayer_NLI_OPR2_PMAP: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_PMAP");
    // },
    // MapLayer_NLI_OPR2_LVST: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_LVST");
    // },
    MapLayer_NLI_OPR2_CHSO: function () {
      return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_CHSO");
    },
    MapLayer_NLI_OPR2_LTYP: function () {
      return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_LTYP");
    },
    MapLayer_NLI_OPR2_ZLES: function () {
      return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_ZLES");
    },
    // MapLayer_NLI_OPR2_OLES: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_OLES");
    // },
    // MapLayer_NLI_OPR2_OPRI: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_OPRI");
    // },
    // MapLayer_NLI_OPR2_OVOD: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_OVOD");
    // },
    // MapLayer_NLI_OPR2_OPUD: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_OPUD");
    // },
    // MapLayer_NLI_OPR2_RZDR: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_RZDR");
    // },
    // MapLayer_NLI_OPR2_SFUN: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_SFUN");
    // },
    // MapLayer_NLI_OPR2_MYSL: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_MYSL");
    // },
    // MapLayer_NLI_OPR2_POSP: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_POSP");
    // },
    // MapLayer_NLI_OPR2_PSOU: function () {
    //   return this.MapLegendLayers.find((item) => item.id == "NLI_OPR2_PSOU");
    // },

    // Vrstvy oprldopravy - viditelnost
    MapLayer_NLI_OPR2_visible: function () {
      return this.MapLayer_NLI_OPR2_CHSO.layer.visible ||
        this.MapLayer_NLI_OPR2_LTYP.layer.visible ||
        this.MapLayer_NLI_OPR2_ZLES.layer.visible
        // this.MapLayer_NLI_OPR2_PMAP.layer.visible ||
        // this.MapLayer_NLI_OPR2_LVST.layer.visible ||
        // this.MapLayer_NLI_OPR2_OLES.layer.visible ||
        // this.MapLayer_NLI_OPR2_OPRI.layer.visible ||
        // this.MapLayer_NLI_OPR2_OVOD.layer.visible ||
        // this.MapLayer_NLI_OPR2_OPUD.layer.visible ||
        // this.MapLayer_NLI_OPR2_RZDR.layer.visible ||
        // this.MapLayer_NLI_OPR2_SFUN.layer.visible ||
        // this.MapLayer_NLI_OPR2_MYSL.layer.visible ||
        // this.MapLayer_NLI_OPR2_POSP.layer.visible ||
        // this.MapLayer_NLI_OPR2_PSOU.layer.visible
    },


    // // Vrstva dopravy - viditelnost
    // MapLayer_NLI_OPR2_ZLES_visible: function () {
    //   return this.MapLayer_NLI_OPR2_ZLES.layer.visible
    // },

    FeatureLayer_NLI_OPRL2_CHSO: function () {
      return AppOpr2.LayerList.find((item) => item.id == "chso");
    },


  },

  watch: {

    // Hledat výraz - suggest
    OprlSearch_Suggest_search(value) {
      // if (value.length > 2) {
      this.OprlSearch_Suggest_isLoading = true;

      this.ServiceMap.SuggestOprl("M_L_Cesty_odvozni", "POR_CIS", value)
        .then((response) => {
          if (response.data.Navrh == null) {
            this.OprlSearch_Suggest_items = [];
            this.OprlSearch_Suggest_isLoading = false;
          } else {
            this.OprlSearch_Suggest_items = response.data.Navrh;
            this.OprlSearch_Suggest_isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.OprlSearch_Suggest_items = [];
          this.OprlSearch_Suggest_isLoading = false;
        })
        .then(function () {
          // always executed
        });
      // }
    },

    // Výběr položky - find a zoom
    OprlSearch_Suggest_model(value) {
      if (value !== null && typeof value !== "undefined") {
        // console.log("MapSearch_Suggest_model");
        // console.log(value);

        this.MapViewZoomToMbr({
          epsg: "EPSG:5514",
          xmin: value.userData.bbox.Xmin,
          ymin: value.userData.bbox.Ymin,
          xmax: value.userData.bbox.Xmax,
          ymax: value.userData.bbox.Ymax,
        })


      }
    },

    // Změna zobrazení vlastní legendylegendy
    MapLayerLegendDynamic_content: function (value) {
      // console.log("MapLayerLegendDynamic_content")
      // console.log(value)

      if (value == this.MapLayerLegendDynamic_contentName) { this.ViewLeg = true } else { this.ViewLeg = false }

    },


  },

  methods: {

    // Filtrování položek
    OprlSearch_Filter: function (item, queryText, itemText) {
      // výchozí je následující funkce
      itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
      // Jenže pak se nezobrazí položky, které mají jiný text
      // např. když pošlu na vyhledávač Mapy.cz
      // '50.2233361N 14.8512964E' vyhledá se '50°13'24.01"N 14°51'4.667"E
      // jenže ten se pak přes tento filtr nedostane, má jiný text
      // pro vyhledávání na MapyCz nás vlastně tento filtr nezajímá, chceme zobrazit vše, co jejich fukce vrátí
      // Uvedené platilo pro MapyCz, ale i pro CUZK se prostě zobrazí vše, co se vrátí, nic se nefiltruje.
      return true;
    },

    // Změna mapového výřezu podle obdelníku
    MapViewZoomToMbr: function (value) {
      this.$emit('MapViewZoomToMbr', value);
    },

    // Zobrazení dynamické mapové legendy - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function () {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapLayerLegendDynamicSet', this.MapLayer_NLI_OPR2_LTYP.id, this.MapLayerLegendDynamic_title, this.MapLayerLegendDynamic_contentName);
    },


  },

  mounted() {
    // První spuštění nástroje
    // console.log("Oprl start");
    // console.log(this.MAP);

    // Základní nastavení - 
    this.LayerList = AppOpr2.LayerList;

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })



  },
};
</script>